import { p as Oo, i as wt, l as kt, u as Je, C as Do, E as Vo, j as n, I as $o, B as ne, F as Fo, h as Ho, m as Go, t as Qo, r as oe, G as z, x as Jo } from "./UnstyledButton-ujNMaBde.js";
import { useCallback as D, useState as H, useEffect as F, useRef as O, useMemo as G, useLayoutEffect as yt } from "react";
import { c as Ko, u as Xo } from "./DirectionProvider-DtCDJ2BX.js";
import { a as dt, L as Zo, d as qo } from "./CloseButton-Bp_UJ8Gq.js";
import { T as Uo, b as Yo, d as se, e as en, a as ae, f as ve, g as Ke, C as tn, P as on, M as nn, h as rn, i as ln, j as an } from "./Table-DyNRNAuP.js";
import { S as sn, C as Xe, T as Se } from "./Checkbox-Uem0EnXG.js";
import { d as ut, P as jt, e as St, f as Pt, G as Ze, A as He, g as cn, h as dn, B as un } from "./Button-CMUmoC07.js";
import './data-table.css';function hn(e, t = "use-local-storage") {
  try {
    return JSON.stringify(e);
  } catch {
    throw new Error(`@mantine/hooks ${t}: Failed to serialize the value`);
  }
}
function mn(e) {
  try {
    return e && JSON.parse(e);
  } catch {
    return e;
  }
}
function gn(e) {
  return { getItem: (l) => {
    try {
      return window[e].getItem(l);
    } catch {
      return console.warn("use-local-storage: Failed to get value from storage, localStorage is blocked"), null;
    }
  }, setItem: (l, a) => {
    try {
      window[e].setItem(l, a);
    } catch {
      console.warn("use-local-storage: Failed to set value to storage, localStorage is blocked");
    }
  }, removeItem: (l) => {
    try {
      window[e].removeItem(l);
    } catch {
      console.warn(
        "use-local-storage: Failed to remove value from storage, localStorage is blocked"
      );
    }
  } };
}
function pn(e, t) {
  const o = "mantine-local-storage", { getItem: r, setItem: l, removeItem: a } = gn(e);
  return function({
    key: s,
    defaultValue: u,
    getInitialValueInEffect: h = !0,
    sync: p = !0,
    deserialize: g = mn,
    serialize: m = (d) => hn(d, t)
  }) {
    const d = D(
      (v) => {
        let P;
        try {
          P = typeof window > "u" || !(e in window) || window[e] === null || !!v;
        } catch {
          P = !0;
        }
        if (P)
          return u;
        const C = r(s);
        return C !== null ? g(C) : u;
      },
      [s, u]
    ), [c, f] = H(d(h)), b = D(
      (v) => {
        v instanceof Function ? f((P) => {
          const C = v(P);
          return l(s, m(C)), queueMicrotask(() => {
            window.dispatchEvent(
              new CustomEvent(o, { detail: { key: s, value: v(P) } })
            );
          }), C;
        }) : (l(s, m(v)), window.dispatchEvent(new CustomEvent(o, { detail: { key: s, value: v } })), f(v));
      },
      [s]
    ), k = D(() => {
      a(s), f(u), window.dispatchEvent(new CustomEvent(o, { detail: { key: s, value: u } }));
    }, [s, u]);
    return ut("storage", (v) => {
      p && v.storageArea === window[e] && v.key === s && f(g(v.newValue ?? void 0));
    }), ut(o, (v) => {
      p && v.detail.key === s && f(v.detail.value);
    }), F(() => {
      u !== void 0 && c === void 0 && b(u);
    }, [u, c, b]), F(() => {
      const v = d();
      v !== void 0 && b(v);
    }, [s]), [c === void 0 ? u : c, b, k];
  };
}
function qe(e) {
  return pn("localStorage", "use-local-storage")(e);
}
function ht(e, t, o = { autoInvoke: !1 }) {
  const r = O(null), l = D(
    (...i) => {
      r.current || (r.current = window.setTimeout(() => {
        e(i), r.current = null;
      }, t));
    },
    [t]
  ), a = D(() => {
    r.current && (window.clearTimeout(r.current), r.current = null);
  }, []);
  return F(() => (o.autoInvoke && l(), a), [a, l]), { start: l, clear: a };
}
const fn = {
  gap: { type: "spacing", property: "gap" },
  rowGap: { type: "spacing", property: "rowGap" },
  columnGap: { type: "spacing", property: "columnGap" },
  align: { type: "identity", property: "alignItems" },
  justify: { type: "identity", property: "justifyContent" },
  wrap: { type: "identity", property: "flexWrap" },
  direction: { type: "identity", property: "flexDirection" }
};
var Tt = { root: "m_8bffd616" };
const Ue = Oo((e, t) => {
  const o = wt("Flex", null, e), {
    classNames: r,
    className: l,
    style: a,
    styles: i,
    unstyled: s,
    vars: u,
    gap: h,
    rowGap: p,
    columnGap: g,
    align: m,
    justify: d,
    wrap: c,
    direction: f,
    attributes: b,
    ...k
  } = o, v = kt({
    name: "Flex",
    classes: Tt,
    props: o,
    className: l,
    style: a,
    classNames: r,
    styles: i,
    unstyled: s,
    attributes: b,
    vars: u
  }), P = Je(), C = Do(), S = Vo({
    styleProps: { gap: h, rowGap: p, columnGap: g, align: m, justify: d, wrap: c, direction: f },
    theme: P,
    data: fn
  });
  return /* @__PURE__ */ n.jsxs(n.Fragment, { children: [
    S.hasResponsiveStyles && /* @__PURE__ */ n.jsx(
      $o,
      {
        selector: `.${C}`,
        styles: S.styles,
        media: S.media
      }
    ),
    /* @__PURE__ */ n.jsx(
      ne,
      {
        ref: t,
        ...v("root", {
          className: C,
          style: Fo(S.inlineStyles)
        }),
        ...k
      }
    )
  ] });
});
Ue.classes = Tt;
Ue.displayName = "@mantine/core/Flex";
var Nt = { root: "m_6d731127" };
const xn = {
  gap: "md",
  align: "stretch",
  justify: "flex-start"
}, bn = Go((e, { gap: t, align: o, justify: r }) => ({
  root: {
    "--stack-gap": Qo(t),
    "--stack-align": o,
    "--stack-justify": r
  }
})), Ye = Ho((e, t) => {
  const o = wt("Stack", xn, e), {
    classNames: r,
    className: l,
    style: a,
    styles: i,
    unstyled: s,
    vars: u,
    align: h,
    justify: p,
    gap: g,
    variant: m,
    attributes: d,
    ...c
  } = o, f = kt({
    name: "Stack",
    props: o,
    classes: Nt,
    className: l,
    style: a,
    classNames: r,
    styles: i,
    unstyled: s,
    attributes: d,
    vars: u,
    varsResolver: bn
  });
  return /* @__PURE__ */ n.jsx(ne, { ref: t, ...f("root"), variant: m, ...c });
});
Ye.classes = Nt;
Ye.displayName = "@mantine/core/Stack";
var [Cn, et] = Ko("useDataTableColumnsContext must be used within DataTableColumnProvider"), mt = (e) => {
  let { children: t, columnsOrder: o, setColumnsOrder: r, columnsToggle: l, setColumnsToggle: a, resetColumnsOrder: i, resetColumnsToggle: s, setColumnWidth: u, setMultipleColumnWidths: h, resetColumnsWidth: p } = e, [g, m] = H(""), [d, c] = H("");
  return n.jsx(Cn, { value: { sourceColumn: g, setSourceColumn: m, targetColumn: d, setTargetColumn: c, columnsToggle: l, setColumnsToggle: a, swapColumns: () => {
    if (!o || !r || !g || !d) return;
    let f = o.indexOf(g), b = o.indexOf(d);
    if (f !== -1 && b !== -1) {
      let k = o.splice(f, 1)[0];
      o.splice(b, 0, k), r([...o]);
    }
  }, resetColumnsOrder: i, resetColumnsToggle: s, setColumnWidth: u, setMultipleColumnWidths: h, resetColumnsWidth: p }, children: t });
};
function vn() {
  return n.jsx("tr", { className: "mantine-datatable-empty-row", children: n.jsx("td", {}) });
}
function wn() {
  return n.jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", children: [n.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), n.jsx("path", { d: "M12.983 8.978c3.955 -.182 7.017 -1.446 7.017 -2.978c0 -1.657 -3.582 -3 -8 -3c-1.661 0 -3.204 .19 -4.483 .515m-2.783 1.228c-.471 .382 -.734 .808 -.734 1.257c0 1.22 1.944 2.271 4.734 2.74" }), n.jsx("path", { d: "M4 6v6c0 1.657 3.582 3 8 3c.986 0 1.93 -.067 2.802 -.19m3.187 -.82c1.251 -.53 2.011 -1.228 2.011 -1.99v-6" }), n.jsx("path", { d: "M4 12v6c0 1.657 3.582 3 8 3c3.217 0 5.991 -.712 7.261 -1.74m.739 -3.26v-4" }), n.jsx("path", { d: "M3 3l18 18" })] });
}
function kn({ icon: e, text: t, active: o, children: r }) {
  return n.jsx(ae, { className: "mantine-datatable-empty-state", "data-active": o || void 0, children: r || n.jsxs(n.Fragment, { children: [e || n.jsx("div", { className: "mantine-datatable-empty-state-icon", children: n.jsx(wn, {}) }), n.jsx(Se, { component: "div", size: "sm", c: "dimmed", children: t })] }) });
}
function yn({ key: e, columns: t = [], getInitialValueInEffect: o = !0 }) {
  function r(g, m) {
    let d = [];
    return g.forEach((c) => {
      m.find((f) => f.accessor === c) && d.push(c);
    }), m.forEach((c) => {
      d.includes(c.accessor) || d.push(c.accessor);
    }), d;
  }
  let l = t && t.map((g) => g.accessor) || [], [a, i] = qe({ key: e ? `${e}-columns-order` : "", defaultValue: e ? l : void 0, getInitialValueInEffect: o });
  function s(g) {
    e && i(g);
  }
  let u = () => {
    s(l);
  };
  if (!e) return { columnsOrder: a, setColumnsOrder: s, resetColumnsOrder: u };
  let h = r(a, t), p = JSON.stringify(a);
  return JSON.stringify(h) !== p && s(h), { columnsOrder: h, setColumnsOrder: s, resetColumnsOrder: u };
}
function jn({ key: e, columns: t = [], getInitialValueInEffect: o = !0, headerRef: r, onFixedLayoutChange: l }) {
  let a = O(!1), i = O({}), [s, u] = H(!0), h = G(() => t.some((x) => x.resizable && !x.hidden && x.accessor !== "__selection__"), [t]), p = G(() => t.filter((x) => x.resizable && !x.hidden && x.accessor !== "__selection__"), [t]), g = G(() => p.some((x) => x.width === void 0 || x.width === "" || x.width === "initial"), [p]), m = D(() => t.filter((x) => x.accessor !== "__selection__").map((x) => ({ [x.accessor]: x.width ?? "auto" })), [t]), [d, c] = qe({ key: e ? `${e}-columns-width` : "", defaultValue: e ? m() : void 0, getInitialValueInEffect: !1 }), [f, b] = H(() => m());
  F(() => {
    u(!1);
  }, []);
  let k = D(() => {
    if (!r?.current || s) return {};
    let x = r.current, N = Array.from(x.querySelectorAll("th[data-accessor]")), M = {};
    return N.forEach((R) => {
      let W = R.getAttribute("data-accessor");
      if (!W || W === "__selection__") return;
      let y = p.find((w) => w.accessor === W);
      if (y && (y.width === void 0 || y.width === "" || y.width === "initial")) {
        let w = R.getBoundingClientRect();
        M[W] = Math.round(w.width);
      }
    }), M;
  }, [r, p, s]), v = D((x) => {
    let N = x.filter((R) => R.accessor !== "__selection__"), M = f.map((R) => {
      let W = Object.keys(R)[0], y = N.find((w) => w.accessor === W);
      return y ? { [W]: y.width } : R;
    });
    b(M), e && c(M);
  }, [f, e, c]), P = D((x) => {
    v(x);
  }, [v]), C = D(() => {
    if (!(!r?.current || !l || s)) if (g) l(!1), requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        let x = k();
        i.current = { ...i.current, ...x };
        let N = t.filter((M) => M.accessor !== "__selection__").map((M) => {
          let R = M.accessor, W = d?.find((w) => Object.keys(w)[0] === R);
          if (W && W[R] !== "auto") return { [R]: W[R] };
          let y = x[R];
          return y ? { [R]: `${y}px` } : { [R]: M.width ?? "auto" };
        });
        b(N), setTimeout(() => {
          l(!0), a.current = !0;
        }, 10);
      });
    });
    else {
      let x = t.filter((N) => N.accessor !== "__selection__").map((N) => ({ [N.accessor]: N.width ?? "auto" }));
      b(x), l(!0), a.current = !0;
    }
  }, [r, l, s, g, k, t, d]), S = C;
  F(() => {
    if (!h || !l || s) {
      l?.(!1);
      return;
    }
    a.current = !1;
    let x = setTimeout(() => {
      C();
    }, 50);
    return () => clearTimeout(x);
  }, [h, l, s, C]), F(() => {
    s || !e || !o || d && d.length > 0 && b(d);
  }, [s, e, o, d]);
  let T = D(() => {
    e && c(m()), i.current = {}, a.current = !1, l && (l(!1), setTimeout(() => {
      C();
    }, 10));
  }, [e, c, m, l, C]), j = D((x, N) => {
    v([{ accessor: x, width: N }]);
  }, [v]), A = G(() => h ? f.filter((x) => {
    let N = Object.keys(x)[0];
    return p.some((M) => M.accessor === N);
  }).every((x) => {
    let N = Object.values(x)[0];
    return N === "auto" || N === "initial";
  }) : !1, [h, f, p]);
  return { columnsWidth: f, setColumnsWidth: v, setColumnWidth: j, setMultipleColumnWidths: P, resetColumnsWidth: T, hasResizableColumns: h, allResizableWidthsInitial: A, measureAndSetColumnWidths: S };
}
function Sn({ key: e, columns: t = [], getInitialValueInEffect: o = !0 }) {
  function r(g, m) {
    let d = [];
    return g.forEach((c) => {
      m.find((f) => f.accessor === c.accessor) && d.push(c);
    }), m.forEach((c) => {
      d.find((f) => f.accessor === c.accessor) || d.push({ accessor: c.accessor, defaultToggle: c.defaultToggle || !0, toggleable: c.toggleable, toggled: c.defaultToggle === void 0 ? !0 : c.defaultToggle });
    }), d;
  }
  let l = t && t.map((g) => ({ accessor: g.accessor, defaultToggle: g.defaultToggle || !0, toggleable: g.toggleable, toggled: g.defaultToggle === void 0 ? !0 : g.defaultToggle })), [a, i] = qe({ key: e ? `${e}-columns-toggle` : "", defaultValue: e ? l : void 0, getInitialValueInEffect: o });
  function s(g) {
    e && i(g);
  }
  let u = () => {
    s(l);
  };
  if (!e) return { columnsToggle: a, setColumnsToggle: s, resetColumnsToggle: u };
  let h = r(a, t), p = JSON.stringify(a);
  return JSON.stringify(h) !== p && s(h), { columnsToggle: h, setColumnsToggle: s, resetColumnsToggle: u };
}
var Pn = ({ key: e, columns: t = [], getInitialValueInEffect: o = !0, headerRef: r, scrollViewportRef: l, onFixedLayoutChange: a }) => {
  let { columnsOrder: i, setColumnsOrder: s, resetColumnsOrder: u } = yn({ key: e, columns: t, getInitialValueInEffect: o }), { columnsToggle: h, setColumnsToggle: p, resetColumnsToggle: g } = Sn({ key: e, columns: t, getInitialValueInEffect: o }), { columnsWidth: m, setColumnsWidth: d, setColumnWidth: c, setMultipleColumnWidths: f, resetColumnsWidth: b, hasResizableColumns: k, allResizableWidthsInitial: v, measureAndSetColumnWidths: P } = jn({ key: e, columns: t, getInitialValueInEffect: o, headerRef: r, onFixedLayoutChange: a });
  return { effectiveColumns: G(() => i ? i.map((C) => t.find((S) => S.accessor === C)).map((C) => ({ ...C, hidden: C?.hidden || !h.find((S) => S.accessor === C?.accessor)?.toggled })).map((C) => C?.accessor === "__selection__" ? C : { ...C, width: m.find((S) => S[C?.accessor])?.[C?.accessor] }) : t, [t, i, h, m]), setColumnsOrder: s, columnsOrder: i, resetColumnsOrder: u, columnsToggle: h, setColumnsToggle: p, resetColumnsToggle: g, columnsWidth: m, setColumnsWidth: d, setColumnWidth: c, setMultipleColumnWidths: f, resetColumnsWidth: b, hasResizableColumns: k, allResizableWidthsInitial: v, measureAndSetColumnWidths: P };
}, gt = typeof window < "u" ? yt : F;
function pt(e) {
  let t = O(e);
  return t.current = e, t;
}
var ft = "--mantine-datatable-header-height", xt = "--mantine-datatable-footer-height", bt = "--mantine-datatable-selection-column-width", Ct = "--mantine-datatable-last-row-border-bottom";
function J(e, t, o) {
  e?.style.setProperty(t, o);
}
function Ge(e) {
  let t = e.borderBoxSize?.[0] || e.contentBoxSize?.[0];
  return t ? { width: t.inlineSize, height: t.blockSize } : { width: e.contentRect.width, height: e.contentRect.height };
}
function $e(e, t, o) {
  if (e) {
    let r = new ResizeObserver((l) => {
      let a = l[0];
      a && t(Ge(a));
    });
    return r.observe(e), () => {
      r.disconnect(), o();
    };
  }
}
function Tn({ scrollCallbacks: e, withRowBorders: t }) {
  let o = { root: O(null), table: O(null), scrollViewport: O(null), header: O(null), footer: O(null), selectionColumnHeader: O(null) }, { root: r, table: l, scrollViewport: a, header: i, footer: s, selectionColumnHeader: u } = o, h = pt({ withRowBorders: t }), p = pt(e), g = O(() => {
  }), m = O(() => {
  }), d = D((c) => {
    p.current.onScroll?.(c), g.current();
  }, []);
  return F(() => $e(i.current, (c) => {
    J(r.current, ft, `${c.height}px`);
  }, () => J(r.current, ft, "0")), [i.current]), F(() => $e(s.current, (c) => {
    J(r.current, xt, `${c.height}px`);
  }, () => J(r.current, xt, "0")), [s.current]), F(() => $e(u.current, (c) => {
    J(r.current, bt, `${c.width}px`);
  }, () => J(r.current, bt, "0")), [u.current]), gt(() => {
    if (typeof window === void 0) return;
    let c = { top: !0, bottom: !0, left: !0, right: !0 }, f = { width: 0, height: 0 }, b = { width: 0, height: 0 };
    function k(T, j) {
      let A = c[T];
      return c[T] = j, J(r.current, `--mantine-datatable-${T}-shadow-opacity`, j ? "0" : "1"), A;
    }
    function v() {
      let T = f.height - b.height, j = T < 0;
      J(r.current, "--mantine-datatable-footer-position", j ? "relative" : "sticky"), J(r.current, "--mantine-datatable-footer-bottom", j ? `${T}px` : "0");
    }
    function P() {
      h.current.withRowBorders && f.height < b.height ? J(r.current, Ct, `${oe("1px")} solid var(--mantine-datatable-border-color)`) : J(r.current, Ct, "unset");
    }
    m.current = P;
    function C() {
      let T = p.current, j = a.current, A = j?.scrollTop ?? 0, x = j?.scrollLeft ?? 0, N = A === 0, M = f.height - A - b.height < 1, R = k("top", N), W = k("bottom", M);
      N && N !== R && T.onScrollToTop?.(), M && M !== W && T.onScrollToBottom?.();
      let y = j ? getComputedStyle(j).direction === "rtl" : !1, w = (j?.scrollWidth ?? 0) - b.width, E, _;
      if (y) {
        let K = Math.abs(x);
        _ = K < 1, E = w - K < 1;
      } else E = x < 1, _ = f.width - x - b.width < 1;
      let $ = k("left", E), L = k("right", _);
      E && E !== $ && T.onScrollToLeft?.(), _ && _ !== L && T.onScrollToRight?.();
    }
    g.current = C;
    let S = new ResizeObserver((T) => {
      for (let j of T) switch (j.target.tagName) {
        case "TABLE": {
          f = Ge(j);
          break;
        }
        case "DIV": {
          b = Ge(j);
          break;
        }
      }
      C(), v(), P();
    });
    return S.observe(l.current), S.observe(a.current), () => {
      S.disconnect();
    };
  }, []), gt(() => {
    m.current();
  }, [t]), { refs: o, onScroll: d };
}
function Nn(e) {
  let [t, o] = H(null), r = e?.join(":") || "";
  return F(() => {
    o(null);
  }, [r]), { lastSelectionChangeIndex: t, setLastSelectionChangeIndex: o };
}
function Rn(e, t) {
  let o = () => {
    t(e.map((l) => l.matches));
  }, r = e.map((l) => {
    try {
      return l.addEventListener("change", o), () => l.removeEventListener("change", o);
    } catch {
      return l.addListener(o), () => l.removeListener(o);
    }
  });
  return () => {
    r.forEach((l) => l());
  };
}
function Wn(e, t) {
  return t || (typeof window < "u" && "matchMedia" in window ? e.map((o) => window.matchMedia(o).matches) : e.map(() => !1));
}
function Mn(e, t, { getInitialValueInEffect: o } = { getInitialValueInEffect: !0 }) {
  let [r, l] = H(o ? t : Wn(e, t)), a = O(null);
  return F(() => {
    if ("matchMedia" in window) return a.current = e.map((i) => window.matchMedia(i)), l(a.current.map((i) => i.matches)), Rn(a.current, (i) => {
      l(i);
    });
  }, [e]), r;
}
function In(e) {
  let t = Je(), o = G(() => e.map((l) => (typeof l == "function" ? l(t) : l) ?? ""), [e, t]), r = G(() => e.map(() => !0), [e]);
  return Mn(o, r);
}
function Pe(e) {
  let t = Je(), o = typeof e == "function" ? e(t) : e;
  return qo(o || "", !0);
}
function tt(e) {
  let t = e.replace(/([a-z\d])([A-Z]+)/g, "$1 $2").replace(/\W|_/g, " ").trim().toLowerCase();
  return `${t.charAt(0).toUpperCase()}${t.slice(1)}`;
}
function An(e, t, o) {
  return e.filter((r) => !t.map(o).includes(o(r)));
}
function Fe(e, t) {
  return e.filter((o, r, l) => r === l.findIndex((a) => t(o) === t(a)));
}
function Rt(e, t) {
  return t ? t.match(/([^[.\]])+/g).reduce((o, r) => o && o[r], e) : void 0;
}
function V(e, t) {
  return typeof t == "string" ? Rt(e, t) : t(e);
}
function Wt(e) {
  return !e || e.length === 0 ? 0 : Math.max(...e.map((t) => t.groups && t.groups.length > 0 ? 1 + Wt(t.groups) : 1));
}
function ot(e) {
  let t = [];
  for (let o of e) o.columns && o.columns.length > 0 ? t.push(...o.columns.filter((r) => r != null)) : o.groups && o.groups.length > 0 && t.push(...ot(o.groups));
  return t.filter((o) => o != null);
}
function Qe(e, t) {
  return e.columns && e.columns.length > 0 ? e.columns.filter((o, r) => o.hidden ? !1 : t ? t[r] !== !1 : !0).length : e.groups && e.groups.length > 0 ? e.groups.reduce((o, r) => o + Qe(r, t), 0) : 0;
}
function Mt(e, t, o = 0) {
  if (o === t) return [...e];
  let r = [];
  for (let l of e) l.groups && l.groups.length > 0 && r.push(...Mt(l.groups, t, o + 1));
  return r;
}
function En(e, t, o) {
  return o ? !e || t : !1;
}
function zn({ rowExpansion: e, records: t, idAccessor: o }) {
  let r = [];
  if (e && t) {
    let { trigger: s, allowMultiple: u, initiallyExpanded: h } = e;
    t && s === "always" ? r = t.map((p) => V(p, o)) : h && (r = t.filter((p, g) => h({ record: p, index: g })).map((p) => V(p, o)), u || (r = [r[0]]));
  }
  let l, a, i = H(r);
  if (e) {
    let { expandable: s, trigger: u, allowMultiple: h, collapseProps: p, content: g } = e;
    e.expanded ? { recordIds: l, onRecordIdsChange: a } = e.expanded : [l, a] = i;
    let m = (d) => a?.(l.filter((c) => c !== V(d, o)));
    return { expandOnClick: u !== "always" && u !== "never", isRowExpanded: (d) => u === "always" ? !0 : l.includes(V(d, o)), isExpandable: ({ record: d, index: c }) => s ? s({ record: d, index: c }) : !0, expandRow: (d) => {
      let c = V(d, o);
      a?.(h ? [...l, c] : [c]);
    }, collapseRow: m, collapseProps: p, content: ({ record: d, index: c }) => () => g({ record: d, index: c, collapse: () => m(d) }) };
  }
}
function _n(e, t) {
  let [o, r] = H(e), [l, a] = H(e), i = ht(() => r(!0), 0), s = ht(() => a(!1), t || 200);
  return F(() => {
    e ? (s.clear(), a(!0), i.start()) : (i.clear(), r(!1), s.start());
  }, [i, s, e]), { expanded: o, visible: l };
}
var nt = "mantine-datatable-nowrap", rt = "mantine-datatable-ellipsis", ie = "mantine-datatable-pointer-cursor", It = "mantine-datatable-context-menu-cursor", Ln = "mantine-datatable-text-selection-disabled", Te = "mantine-datatable-text-align-left", Ne = "mantine-datatable-text-align-center", Re = "mantine-datatable-text-align-right";
function Bn({ className: e, style: t, visibleMediaQuery: o, title: r, noWrap: l, ellipsis: a, textAlign: i, width: s }) {
  return Pe(o) ? n.jsx(ve, { className: z({ [nt]: l || a, [rt]: a, [Te]: i === "left", [Ne]: i === "center", [Re]: i === "right" }, e), style: [{ width: s, minWidth: s, maxWidth: s }, t], children: r }) : null;
}
function On({ shadowVisible: e }) {
  return n.jsx(ve, { className: "mantine-datatable-footer-selector-placeholder-cell", "data-shadow-visible": e || void 0 });
}
function Dn({ className: e, style: t, columns: o, defaultColumnProps: r, selectionVisible: l, selectorCellShadowVisible: a, ref: i }) {
  return n.jsx(en, { ref: i, className: z("mantine-datatable-footer", e), style: t, children: n.jsxs(se, { children: [l && n.jsx(On, { shadowVisible: a }), o.map(({ hidden: s, ...u }) => {
    if (s) return null;
    let { accessor: h, visibleMediaQuery: p, textAlign: g, width: m, footer: d, footerClassName: c, footerStyle: f, noWrap: b, ellipsis: k } = { ...r, ...u };
    return n.jsx(Bn, { className: c, style: f, visibleMediaQuery: p, textAlign: g, width: m, title: d, noWrap: b, ellipsis: k }, h);
  })] }) });
}
function Vn({ group: { id: e, columns: t, groups: o, title: r, textAlign: l, className: a, style: i }, maxDepth: s, currentDepth: u, previousGroups: h, isLastGroup: p, withColumnBorders: g = !1, totalTableColumns: m }) {
  let d = G(() => t && t.length > 0 ? t : o && o.length > 0 ? ot([{ id: e, columns: t, groups: o }]) : [], [t, o, e]), c = G(() => d.map(({ visibleMediaQuery: S }) => S), [d]), f = In(c), b = G(() => Qe({ columns: t, groups: o }, f), [e, t, o, f]), k = G(() => h.reduce((S, T) => S + Qe(T, f), 0), [h, f]), v = o && o.length > 0 ? 1 : s - u, P = k + b < m, C = En(p, P, g);
  return b > 0 ? n.jsx(ve, { colSpan: b, rowSpan: v > 1 ? v : void 0, className: z("mantine-datatable-column-group-header-cell", { [Te]: l === "left", [Ne]: l === "center", [Re]: l === "right", "mantine-datatable-column-group-header-cell--needs-border": C }, a), style: i, children: r ?? tt(e) }) : null;
}
function $n() {
  return n.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", children: [n.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), n.jsx("path", { d: "M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z" })] });
}
function Fn() {
  return n.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", children: [n.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), n.jsx("path", { d: "M20 3h-16a1 1 0 0 0 -1 1v2.227l.008 .223a3 3 0 0 0 .772 1.795l4.22 4.641v8.114a1 1 0 0 0 1.316 .949l6 -2l.108 -.043a1 1 0 0 0 .576 -.906v-6.586l4.121 -4.12a3 3 0 0 0 .879 -2.123v-2.171a1 1 0 0 0 -1 -1z", strokeWidth: "0", fill: "currentColor" })] });
}
function Hn({ children: e, isActive: t, filterPopoverProps: o, filterPopoverDisableClickOutside: r }) {
  let [l, { close: a, toggle: i }] = cn(!1), s = t ? Fn : $n, u = dn(a);
  return r && (u = void 0), n.jsxs(jt, { withArrow: !0, shadow: "md", opened: l, onClose: a, trapFocus: !0, ...o, children: [n.jsx(St, { children: n.jsx(He, { className: "mantine-datatable-header-cell-filter-action-icon", "data-active": t || void 0, size: "sm", variant: "default", onClick: (h) => {
    h.preventDefault(), i();
  }, onKeyDown: (h) => h.stopPropagation(), children: n.jsx(s, {}) }) }), n.jsx(Pt, { ref: u, onClick: (h) => h.stopPropagation(), onKeyDown: (h) => h.stopPropagation(), children: typeof e == "function" ? e({ close: a }) : e })] });
}
var Gn = (e) => {
  let { accessor: t, columnRef: o } = e, [r, l] = H(!1), a = O(0), i = O({ current: 0, next: 0 }), { dir: s } = Xo(), u = s === "rtl", { setMultipleColumnWidths: h } = et(), p = D((m) => {
    if (m.preventDefault(), m.stopPropagation(), !o.current) return;
    let d = o.current, c = d.nextElementSibling;
    for (; c; ) {
      let S = c.getAttribute("data-accessor");
      if (S && S !== "__selection__") break;
      c = c.nextElementSibling;
    }
    if (!c) return;
    let f = c.getAttribute("data-accessor");
    if (!f) return;
    let b = f === "__selection__";
    l(!0), a.current = m.clientX;
    let k = d.offsetWidth, v = c.offsetWidth;
    i.current = { current: k, next: v };
    let P = (S) => {
      if (!o.current) return;
      let T = o.current, j = T.nextElementSibling;
      if (!j) return;
      let A = S.clientX - a.current;
      u && (A = -A);
      let x = 50, N = i.current.current - x, M = i.current.next - x, R = Math.max(-N, Math.min(A, M)), W = i.current.current + R, y = i.current.next - R;
      T.style.width = `${W}px`, j.style.width = `${y}px`, T.style.minWidth = `${W}px`, T.style.maxWidth = `${W}px`, j.style.minWidth = `${y}px`, j.style.maxWidth = `${y}px`;
    }, C = () => {
      if (!o.current) return;
      let S = o.current, T = S.nextElementSibling;
      l(!1), document.body.style.cursor = "initial", document.body.style.userSelect = "initial";
      let j = parseInt(S.style.width) || S.offsetWidth, A = T ? parseInt(T.style.width) || T.offsetWidth : 0, x = [{ accessor: t, width: `${j}px` }];
      if (T && !b) {
        let N = T.getAttribute("data-accessor");
        N && x.push({ accessor: N, width: `${A}px` });
      }
      setTimeout(() => {
        h(x);
      }, 0), document.removeEventListener("mousemove", P), document.removeEventListener("mouseup", C);
    };
    document.body.style.cursor = "col-resize", document.body.style.userSelect = "none", document.addEventListener("mousemove", P), document.addEventListener("mouseup", C);
  }, [t, o, u, h]), g = D(() => {
    if (!o.current) return;
    let m = o.current, d = m.nextElementSibling;
    m.style.width = "", m.style.minWidth = "", m.style.maxWidth = "";
    let c = [{ accessor: t, width: "auto" }];
    if (d) {
      d.style.width = "", d.style.minWidth = "", d.style.maxWidth = "";
      let f = d.getAttribute("data-accessor");
      f && f !== "__selection__" && c.push({ accessor: f, width: "auto" });
    }
    setTimeout(() => {
      h(c);
    }, 0);
  }, [t, o, h]);
  return n.jsx("div", { className: "mantine-datatable-header-resizable-handle", style: { cursor: r ? "col-resize" : void 0 }, onMouseDown: p, onDoubleClick: g, onClick: (m) => m.stopPropagation(), title: "Drag to resize column, double-click to reset" });
};
function Qn() {
  return n.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", children: [n.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), n.jsx("path", { d: "M12 5l0 14" }), n.jsx("path", { d: "M16 9l-4 -4" }), n.jsx("path", { d: "M8 9l4 -4" })] });
}
function Jn() {
  return n.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", children: [n.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), n.jsx("path", { d: "M8 7l4 -4l4 4" }), n.jsx("path", { d: "M8 17l4 4l4 -4" }), n.jsx("path", { d: "M12 3l0 18" })] });
}
function Kn() {
  return n.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", children: [n.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), n.jsx("path", { d: "M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }), n.jsx("path", { d: "M9 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }), n.jsx("path", { d: "M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }), n.jsx("path", { d: "M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }), n.jsx("path", { d: "M15 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }), n.jsx("path", { d: "M15 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" })] });
}
function Xn() {
  return n.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", children: [n.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), n.jsx("path", { d: "M18 6l-12 12" }), n.jsx("path", { d: "M6 6l12 12" })] });
}
function Zn({ className: e, style: t, accessor: o, visibleMediaQuery: r, title: l, sortable: a, draggable: i, toggleable: s, resizable: u, sortIcons: h, textAlign: p, width: g, sortStatus: m, onSortStatusChange: d, filter: c, filterPopoverProps: f, filterPopoverDisableClickOutside: b, filtering: k, sortKey: v }) {
  let { setSourceColumn: P, setTargetColumn: C, swapColumns: S, setColumnsToggle: T } = et(), [j, A] = H(!1), x = O(null);
  if (!Pe(r)) return null;
  let N = l ?? tt(o), M = typeof N == "string" ? N : void 0, R = a && d ? (L) => {
    L?.defaultPrevented || d({ sortKey: v, columnAccessor: o, direction: m?.columnAccessor === o ? m.direction === "asc" ? "desc" : "asc" : m?.direction ?? "asc" });
  } : void 0, W = (L) => {
    L.stopPropagation(), P(o), A(!1);
  }, y = (L) => {
    L.preventDefault(), C(o), A(!0);
  }, w = () => {
    C(o), A(!1), S();
  }, E = () => {
    A(!0);
  }, _ = () => {
    A(!1);
  }, $ = (L) => {
    L.stopPropagation(), T((K) => K.map((Z) => Z.accessor === o ? { ...Z, toggled: !1 } : Z));
  };
  return n.jsxs(ve, { "data-accessor": o, className: z({ "mantine-datatable-header-cell-sortable": a, "mantine-datatable-header-cell-toggleable": s, "mantine-datatable-header-cell-resizable": u }, e), style: [{ width: g, ...u ? {} : { minWidth: g, maxWidth: g } }, t], role: a ? "button" : void 0, tabIndex: a ? 0 : void 0, onClick: R, onKeyDown: (L) => L.key === "Enter" && R?.(), ref: x, children: [n.jsxs(Ze, { className: "mantine-datatable-header-cell-sortable-group", justify: "space-between", wrap: "nowrap", children: [n.jsxs(Ue, { align: "center", w: "100%", className: z({ "mantine-datatable-header-cell-draggable": i, "mantine-datatable-header-cell-drag-over": j }), draggable: i, onDragStart: i ? W : void 0, onDragEnter: i ? E : void 0, onDragOver: i ? y : void 0, onDrop: i ? w : void 0, onDragLeave: i ? _ : void 0, children: [i ? n.jsx(ae, { role: "img", "aria-label": "Drag column", children: n.jsx(He, { className: "mantine-datatable-header-cell-draggable-action-icon", variant: "subtle", size: "xs", onClick: (L) => {
    L.stopPropagation();
  }, children: n.jsx(Kn, {}) }) }) : null, n.jsx(ne, { className: z("mantine-datatable-header-cell-sortable-text", { [Te]: p === "left", [Ne]: p === "center", [Re]: p === "right" }, nt, rt), title: M, children: N })] }), s ? n.jsx(ae, { className: "mantine-datatable-header-cell-toggleable-icon", role: "img", "aria-label": "Toggle column", children: n.jsx(He, { size: "xs", variant: "light", onClick: $, children: n.jsx(Xn, {}) }) }) : null, a || m?.columnAccessor === o ? n.jsx(n.Fragment, { children: m?.columnAccessor === o ? n.jsx(ae, { className: z("mantine-datatable-header-cell-sortable-icon", { "mantine-datatable-header-cell-sortable-icon-reversed": m.direction === "desc" }), role: "img", "aria-label": `Sorted ${m.direction === "desc" ? "descending" : "ascending"}`, children: h?.sorted || n.jsx(Qn, {}) }) : n.jsx(ae, { className: "mantine-datatable-header-cell-sortable-unsorted-icon", role: "img", "aria-label": "Not sorted", children: h?.unsorted || n.jsx(Jn, {}) }) }) : null, c ? n.jsx(Hn, { filterPopoverProps: f, isActive: !!k, filterPopoverDisableClickOutside: b, children: c }) : null] }), u && o !== "__selection__" ? n.jsx(Gn, { accessor: o, columnRef: x }) : null] });
}
function qn({ className: e, style: t, trigger: o, shadowVisible: r, checked: l, indeterminate: a, checkboxProps: i, onChange: s, rowSpan: u, ref: h }) {
  let p = !i.disabled;
  return n.jsx(ve, { ref: h, className: z("mantine-datatable-header-selector-cell", { [ie]: o === "cell" && p }, e), style: t, rowSpan: u, "data-shadow-visible": r || void 0, "data-accessor": "__selection__", onClick: o === "cell" && p ? s : void 0, children: n.jsx(Xe, { classNames: p ? { input: ie } : void 0, checked: l, indeterminate: a, onChange: s, ...i, disabled: !(s || i.onChange) || i.disabled }) });
}
function Un({ selectionColumnHeaderRef: e, className: t, style: o, sortStatus: r, sortIcons: l, onSortStatusChange: a, columns: i, defaultColumnProps: s, groups: u, selectionTrigger: h, selectionVisible: p, selectionChecked: g, selectionIndeterminate: m, onSelectionChange: d, selectionCheckboxProps: c, selectorCellShadowVisible: f, selectionColumnClassName: b, selectionColumnStyle: k, withColumnBorders: v = !1, ref: P }) {
  let C = u ? Wt(u) : 0, S = C > 0 ? C + 1 : 1, T = p ? n.jsx(qn, { ref: e, className: b, style: k, trigger: h, shadowVisible: f, checked: g, indeterminate: m, checkboxProps: c, onChange: d, rowSpan: u ? S : void 0 }) : null, { columnsToggle: j, setColumnsToggle: A } = et(), [x, N] = H(!1), M = i.some((y) => y.toggleable), R = M ? Object.fromEntries(i.map(({ accessor: y, title: w }) => [y, w ?? tt(String(y))])) : void 0, W = n.jsxs(Yo, { className: z("mantine-datatable-header", t), style: o, ref: P, onContextMenu: M ? (y) => {
    y.preventDefault(), N((w) => !w);
  } : void 0, children: [u && Array.from({ length: C }, (y, w) => {
    let E = Mt(u, w);
    return n.jsxs(se, { children: [w === 0 && T, E.map((_, $) => n.jsx(Vn, { group: _, maxDepth: C, currentDepth: w, previousGroups: E.slice(0, $), isLastGroup: $ === E.length - 1, withColumnBorders: v, totalTableColumns: i.length }, _.id))] }, `group-depth-${w}`);
  }), n.jsxs(se, { children: [!u && T, i.map(({ hidden: y, ...w }, E) => {
    if (y) return null;
    let { accessor: _, visibleMediaQuery: $, textAlign: L, width: K, title: Z, sortable: ce, draggable: de, toggleable: ue, resizable: he, titleClassName: U, titleStyle: me, filter: ge, filterPopoverProps: q, filterPopoverDisableClickOutside: We, filtering: Me, sortKey: Ie } = { ...s, ...w };
    return n.jsx(Zn, { accessor: _, className: U, style: me, visibleMediaQuery: $, textAlign: L, width: K, title: Z, sortable: ce, draggable: de, toggleable: ue, resizable: he && E < i.length - 1, sortStatus: r, sortIcons: l, sortKey: Ie, onSortStatusChange: a, filter: ge, filterPopoverProps: q, filterPopoverDisableClickOutside: We, filtering: Me }, _);
  })] })] });
  return M ? n.jsxs(jt, { position: "bottom", withArrow: !0, shadow: "md", opened: x, onChange: N, children: [n.jsx(St, { children: W }), n.jsx(Pt, { children: n.jsx(Ye, { children: j.filter((y) => y.toggleable).map((y) => n.jsx(Ze, { children: n.jsx(Xe, { classNames: { label: "mantine-datatable-header-column-toggle-checkbox-label" }, size: "xs", label: R[y.accessor], checked: y.toggled, onChange: (w) => {
    A(j.map((E) => E.accessor === y.accessor ? { ...E, toggled: w.currentTarget.checked } : E));
  } }) }, y.accessor)) }) })] }) : W;
}
function Yn({ fetching: e, customContent: t, backgroundBlur: o, size: r, type: l, color: a }) {
  return n.jsx(ae, { className: z("mantine-datatable-loader", { "mantine-datatable-loader-fetching": e }), style: [{ backdropFilter: o ? `blur(${o}px)` : void 0 }], children: e && (t || n.jsx(Zo, { size: r, type: l, color: a })) });
}
function B(e, t, o) {
  return e ? Jo({ color: typeof e == "object" ? e[o] : e, theme: t }).value : void 0;
}
function er({ theme: e, c: t, backgroundColor: o, borderColor: r, rowBorderColor: l, stripedColor: a, highlightOnHoverColor: i }) {
  return { "--mantine-datatable-color-light": B(t, e, "light"), "--mantine-datatable-color-dark": B(t, e, "dark"), "--mantine-datatable-background-color-light": B(o, e, "light"), "--mantine-datatable-background-color-dark": B(o, e, "dark"), "--mantine-datatable-border-color-light": B(r, e, "light"), "--mantine-datatable-border-color-dark": B(r, e, "dark"), "--mantine-datatable-row-border-color-light": B(l, e, "light"), "--mantine-datatable-row-border-color-dark": B(l, e, "dark"), "--mantine-datatable-striped-color-light": B(a, e, "light"), "--mantine-datatable-striped-color-dark": B(a, e, "dark"), "--mantine-datatable-highlight-on-hover-color-light": B(i, e, "light"), "--mantine-datatable-highlight-on-hover-color-dark": B(i, e, "dark") };
}
function At({ theme: e, paginationActiveTextColor: t, paginationActiveBackgroundColor: o }) {
  return { "--mantine-datatable-pagination-active-text-color-light": B(t, e, "light"), "--mantine-datatable-pagination-active-text-color-dark": B(t, e, "dark"), "--mantine-datatable-pagination-active-background-color-light": B(o, e, "light"), "--mantine-datatable-pagination-active-background-color-dark": B(o, e, "dark") };
}
function tr({ theme: e, color: t, backgroundColor: o }) {
  return { "--mantine-datatable-row-color-light": B(t, e, "light"), "--mantine-datatable-row-color-dark": B(t, e, "dark"), "--mantine-datatable-row-background-color-light": B(o, e, "light"), "--mantine-datatable-row-background-color-dark": B(o, e, "dark") };
}
function or() {
  return n.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", children: [n.jsx("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }), n.jsx("path", { d: "M8 9l4 -4l4 4" }), n.jsx("path", { d: "M16 15l-4 4l-4 -4" })] });
}
var vt = { xs: oe(22), sm: oe(26), md: oe(32), lg: oe(38), xl: oe(44) };
function nr({ size: e, label: t, values: o, value: r, activeTextColor: l, activeBackgroundColor: a, onChange: i }) {
  return n.jsxs(Ze, { gap: "xs", children: [n.jsx(Se, { component: "div", size: e, children: t }), n.jsxs(nn, { withinPortal: !0, withArrow: !0, offset: 2, classNames: { arrow: "mantine-datatable-page-size-selector-menu-arrow" }, children: [n.jsx(rn, { children: n.jsx(un, { size: e, variant: "default", classNames: { section: "mantine-datatable-page-size-selector-button-icon" }, rightSection: n.jsx(or, {}), style: [{ fontWeight: "normal" }, (s) => ({ height: vt[e], paddingLeft: s.spacing[e], paddingRight: s.spacing[e] })], children: r }) }), n.jsx(ln, { children: o.map((s) => {
    let u = s === r;
    return n.jsx(an, { className: z({ "mantine-datatable-page-size-selector-active": u }), style: [{ height: vt[e] }, u && (l || a) ? (h) => At({ theme: h, paginationActiveTextColor: l, paginationActiveBackgroundColor: a }) : void 0], disabled: u, onClick: () => i(s), children: n.jsx(Se, { component: "div", size: e, children: s }) }, s);
  }) })] })] });
}
function rr({ className: e, style: t, fetching: o, page: r, onPageChange: l, paginationWithEdges: a, paginationWithControls: i, paginationActiveTextColor: s, paginationActiveBackgroundColor: u, paginationSize: h, loadingText: p, noRecordsText: g, paginationText: m, totalRecords: d, recordsPerPage: c, onRecordsPerPageChange: f, recordsPerPageLabel: b, recordsPerPageOptions: k, recordsLength: v, horizontalSpacing: P, paginationWrapBreakpoint: C, getPaginationControlProps: S, getPaginationItemProps: T, renderPagination: j }) {
  let A;
  if (d) {
    let w = (r - 1) * c + 1, E = w + (v || 0) - 1;
    A = m({ from: w, to: E, totalRecords: d });
  } else A = o ? p : g;
  let x = d && c ? Math.max(1, Math.ceil(d / c)) : 1, N = d ? (r - 1) * (c ?? 0) + 1 : void 0, M = d ? (N ?? 1) + (v ?? 0) - 1 : void 0, R = !Pe(({ breakpoints: w }) => `(min-width: ${typeof C == "number" ? `${oe(C)}rem` : w[C] || C})`), W = { Text: (w) => n.jsx(Se, { component: "div", className: "mantine-datatable-pagination-text", size: h, ...w, children: A }), PageSizeSelector: (w) => k ? n.jsx(nr, { activeTextColor: s, activeBackgroundColor: u, size: h, label: b, values: k, value: c, onChange: f, ...w }) : n.jsx(n.Fragment, {}), Pagination: (w) => n.jsx(on, { classNames: { root: z("mantine-datatable-pagination-pages", { "mantine-datatable-pagination-pages-fetching": o || !v }), control: "mantine-datatable-pagination-pages-control" }, style: s || u ? (E) => At({ theme: E, paginationActiveTextColor: s, paginationActiveBackgroundColor: u }) : void 0, withEdges: a, withControls: i, value: r, onChange: l, size: h, total: x, getControlProps: S, getItemProps: T, ...w }) }, y = { state: { paginationSize: h, page: r, totalPages: x, totalRecords: d, recordsPerPage: c, recordsLength: v, fetching: o, from: N, to: M, isWrapped: R }, actions: { setPage: (w) => l?.(w), setRecordsPerPage: f ? (w) => f(w) : void 0 }, Controls: W };
  return n.jsx(ne, { px: P ?? "xs", py: "xs", className: z("mantine-datatable-pagination", e), style: [{ flexDirection: R ? "column" : "row" }, t], children: typeof j == "function" ? j(y) : n.jsxs(n.Fragment, { children: [n.jsx(W.Text, {}), n.jsx(W.PageSizeSelector, {}), n.jsx(W.Pagination, {})] }) });
}
function lr({ className: e, style: t, visibleMediaQuery: o, record: r, index: l, onClick: a, onDoubleClick: i, onContextMenu: s, noWrap: u, ellipsis: h, textAlign: p, width: g, accessor: m, render: d, defaultRender: c, customCellAttributes: f }) {
  return Pe(o) ? n.jsx(Ke, { className: z({ [nt]: u || h, [rt]: h, [ie]: a || i, [It]: s, [Te]: p === "left", [Ne]: p === "center", [Re]: p === "right" }, e), style: [{ width: g, minWidth: g, maxWidth: g }, t], onClick: a, onDoubleClick: i, onContextMenu: s, ...f?.(r, l), children: d ? d(r, l) : c ? c(r, l, m) : Rt(r, m) }) : null;
}
function ar({ open: e, colSpan: t, content: o, collapseProps: r }) {
  let { expanded: l, visible: a } = _n(e, r?.transitionDuration);
  return a ? n.jsxs(n.Fragment, { children: [n.jsx(se, {}), n.jsx(se, { children: n.jsx(Ke, { className: "mantine-datatable-row-expansion-cell", colSpan: t, children: n.jsx(tn, { in: l, ...r, children: n.jsx("div", { className: "mantine-datatable-row-expansion-cell-content", children: o() }) }) }) })] }) : null;
}
function sr({ className: e, style: t, record: o, index: r, trigger: l, onChange: a, withRightShadow: i, checkboxProps: s, getCheckboxProps: u, ...h }) {
  let p = { ...s, ...u(o, r) }, g = !h.disabled && !p.disabled, m = (d) => {
    d.stopPropagation(), l === "cell" && g && a?.(d);
  };
  return n.jsx(Ke, { className: z("mantine-datatable-row-selector-cell", { [ie]: l === "cell" && g }, e), style: t, "data-shadow-visible": i || void 0, onClick: m, children: n.jsx(Xe, { classNames: g ? { input: ie } : void 0, onChange: a, ...h, ...p }) });
}
function ir({ record: e, index: t, columns: o, defaultColumnProps: r, defaultColumnRender: l, selectionTrigger: a, selectionVisible: i, selectionChecked: s, onSelectionChange: u, isRecordSelectable: h, selectionCheckboxProps: p, getSelectionCheckboxProps: g, onClick: m, onDoubleClick: d, onContextMenu: c, onCellClick: f, onCellDoubleClick: b, onCellContextMenu: k, expansion: v, customAttributes: P, color: C, backgroundColor: S, className: T, style: j, selectorCellShadowVisible: A, selectionColumnClassName: x, selectionColumnStyle: N, rowFactory: M }) {
  let R = n.jsxs(n.Fragment, { children: [i && n.jsx(sr, { className: x, style: N, record: e, index: t, trigger: a, withRightShadow: A, checked: s, disabled: !u || (h ? !h(e, t) : !1), onChange: u, checkboxProps: p, getCheckboxProps: g }), o.map(({ hidden: w, hiddenContent: E, ..._ }, $) => {
    if (w || E) return null;
    let { accessor: L, visibleMediaQuery: K, textAlign: Z, noWrap: ce, ellipsis: de, width: ue, render: he, cellsClassName: U, cellsStyle: me, customCellAttributes: ge } = { ...r, ..._ };
    return n.jsx(lr, { className: typeof U == "function" ? U(e, t) : U, style: me?.(e, t), visibleMediaQuery: K, record: e, index: t, onClick: f ? (q) => f({ event: q, record: e, index: t, column: _, columnIndex: $ }) : void 0, onDoubleClick: b ? (q) => b({ event: q, record: e, index: t, column: _, columnIndex: $ }) : void 0, onContextMenu: k ? (q) => k({ event: q, record: e, index: t, column: _, columnIndex: $ }) : void 0, accessor: L, textAlign: Z, noWrap: ce, ellipsis: de, width: ue, render: he, defaultRender: l, customCellAttributes: ge }, L);
  })] }), W = v && n.jsx(ar, { colSpan: o.filter(({ hidden: w }) => !w).length + (i ? 1 : 0), open: v.isRowExpanded(e), content: v.content({ record: e, index: t }), collapseProps: v.collapseProps }), y = cr({ record: e, index: t, selectionChecked: s, onClick: m, onDoubleClick: d, onContextMenu: c, expansion: v, customAttributes: P, color: C, backgroundColor: S, className: T, style: j });
  return M ? M({ record: e, index: t, rowProps: y, children: R, expandedElement: W }) : n.jsxs(n.Fragment, { children: [n.jsx(se, { ...y, children: R }), W] });
}
function cr({ record: e, index: t, selectionChecked: o, onClick: r, onDoubleClick: l, onContextMenu: a, expansion: i, customAttributes: s, color: u, backgroundColor: h, className: p, style: g }) {
  return { className: z("mantine-datatable-row", { [ie]: r || l || i?.isExpandable({ record: e, index: t }) && i?.expandOnClick }, { [It]: a }, typeof p == "function" ? p(e, t) : p), "data-selected": o || void 0, onClick: (m) => {
    if (i) {
      let { isExpandable: d, isRowExpanded: c, expandOnClick: f, expandRow: b, collapseRow: k } = i;
      d({ record: e, index: t }) && f && (c(e) ? k(e) : b(e));
    }
    r?.({ event: m, record: e, index: t });
  }, onDoubleClick: l ? (m) => l({ event: m, record: e, index: t }) : void 0, onContextMenu: a ? (m) => a({ event: m, record: e, index: t }) : void 0, style: [u || h ? (m) => {
    let d = u?.(e, t), c = h?.(e, t);
    return tr({ theme: m, color: d, backgroundColor: c });
  } : void 0, g?.(e, t)], ...s?.(e, t) ?? {} };
}
function dr({ leftShadowBehind: e, rightShadowBehind: t, onScrollPositionChange: o, children: r, viewportRef: l, scrollAreaProps: a }) {
  return n.jsxs(sn, { ...a, viewportRef: l, classNames: { root: "mantine-datatable-scroll-area", scrollbar: "mantine-datatable-scroll-area-scrollbar", thumb: "mantine-datatable-scroll-area-thumb", corner: "mantine-datatable-scroll-area-corner" }, onScrollPositionChange: o, children: [r, n.jsx(ne, { className: z("mantine-datatable-scroll-area-shadow", "mantine-datatable-scroll-area-top-shadow") }), n.jsx("div", { className: z("mantine-datatable-scroll-area-shadow", "mantine-datatable-scroll-area-left-shadow", { "mantine-datatable-scroll-area-shadow-behind": e }) }), n.jsx("div", { className: z("mantine-datatable-scroll-area-shadow", "mantine-datatable-scroll-area-right-shadow", { "mantine-datatable-scroll-area-shadow-behind": t }) }), n.jsx(ne, { className: z("mantine-datatable-scroll-area-shadow", "mantine-datatable-scroll-area-bottom-shadow") })] });
}
function ur({ withTableBorder: e, borderRadius: t, textSelectionDisabled: o, height: r = "100%", minHeight: l, maxHeight: a, shadow: i, verticalAlign: s = "center", fetching: u, columns: h, storeColumnsKey: p, groups: g, pinFirstColumn: m, pinLastColumn: d, defaultColumnProps: c, defaultColumnRender: f, idAccessor: b = "id", records: k, selectionTrigger: v = "checkbox", selectedRecords: P, onSelectedRecordsChange: C, selectionColumnClassName: S, selectionColumnStyle: T, isRecordSelectable: j, selectionCheckboxProps: A, allRecordsSelectionCheckboxProps: x = { "aria-label": "Select all records" }, getRecordSelectionCheckboxProps: N = (Q, xe) => ({ "aria-label": `Select record ${xe + 1}` }), sortStatus: M, sortIcons: R, onSortStatusChange: W, horizontalSpacing: y, page: w, onPageChange: E, totalRecords: _, recordsPerPage: $, onRecordsPerPageChange: L, recordsPerPageOptions: K, recordsPerPageLabel: Z = "Records per page", paginationWithEdges: ce, paginationWithControls: de, paginationActiveTextColor: ue, paginationActiveBackgroundColor: he, paginationSize: U = "sm", paginationText: me = ({ from: Q, to: xe, totalRecords: ze }) => `${Q} - ${xe} / ${ze}`, paginationWrapBreakpoint: ge = "sm", getPaginationControlProps: q = (Q) => Q === "previous" ? { "aria-label": "Previous page" } : Q === "next" ? { "aria-label": "Next page" } : {}, getPaginationItemProps: We, renderPagination: Me, loaderBackgroundBlur: Ie, customLoader: Et, loaderSize: zt, loaderType: _t, loaderColor: Lt, loadingText: Bt = "...", emptyState: Ot, noRecordsText: lt = "No records", noRecordsIcon: Dt, highlightOnHover: Vt, striped: $t, noHeader: Ft, onRowClick: Ht, onRowDoubleClick: Gt, onRowContextMenu: Qt, onCellClick: Jt, onCellDoubleClick: Kt, onCellContextMenu: Xt, onScroll: Zt, onScrollToTop: qt, onScrollToBottom: Ut, onScrollToLeft: Yt, onScrollToRight: eo, c: to, backgroundColor: oo, borderColor: no, rowBorderColor: ro, stripedColor: lo, highlightOnHoverColor: ao, rowColor: so, rowBackgroundColor: io, rowExpansion: co, rowClassName: uo, rowStyle: ho, customRowAttributes: mo, scrollViewportRef: go, scrollAreaProps: po, tableRef: fo, bodyRef: xo, m: bo, my: Co, mx: vo, mt: wo, mb: ko, ml: yo, mr: jo, className: So, classNames: pe, style: Po, styles: fe, rowFactory: To, tableWrapper: Ae, ...Ee }) {
  let Q = G(() => g ? ot(g) : h, [h, g]), [xe, ze] = H(!1), { refs: X, onScroll: No } = Tn({ scrollCallbacks: { onScroll: Zt, onScrollToTop: qt, onScrollToBottom: Ut, onScrollToLeft: Yt, onScrollToRight: eo }, withRowBorders: Ee.withRowBorders }), _e = Pn({ key: p, columns: Q, headerRef: X.header, scrollViewportRef: X.scrollViewport, onFixedLayoutChange: ze }), Ro = dt(X.table, fo), Wo = dt(X.scrollViewport, go), Mo = zn({ rowExpansion: co, records: k, idAccessor: b }), we = O(!1), at = O(w), Le = O(k), Io = D((I) => {
    we.current = !0, Le.current = k, E(I);
  }, [E, k]);
  F(() => {
    at.current !== w && (we.current = !0, Le.current = k, at.current = w);
  }, [w, k]);
  let be = k?.length;
  yt(() => {
    if (!we.current || u || k === Le.current) return;
    let I = X.scrollViewport.current;
    if (!I) return;
    let Y = requestAnimationFrame(() => {
      I.scrollTo({ top: 0, left: 0 }), we.current = !1;
    });
    return () => cancelAnimationFrame(Y);
  }, [u, k, X.scrollViewport]);
  let st = k?.map((I) => V(I, b)), re = !!P, Ce = P?.map((I) => V(I, b)), it = st !== void 0 && Ce !== void 0 && Ce.length > 0, Be = j ? k?.filter(j) : k, ke = Be?.map((I) => V(I, b)), ye = it && ke.every((I) => Ce.includes(I)), Ao = it && ke.some((I) => Ce.includes(I)), Eo = D(() => {
    P && C && C(ye ? P.filter((I) => !ke.includes(V(I, b))) : Fe([...P, ...Be], (I) => V(I, b)));
  }, [ye, b, C, ke, Be, P]), { lastSelectionChangeIndex: je, setLastSelectionChangeIndex: zo } = Nn(st), Oe = re && !m, _o = { m: bo, my: Co, mx: vo, mt: wo, mb: ko, ml: yo, mr: jo }, Lo = D(({ children: I }) => Ae ? Ae({ children: I }) : I, [Ae]);
  return n.jsx(mt, { ..._e, children: n.jsxs(ne, { ref: X.root, ..._o, className: z("mantine-datatable", { "mantine-datatable-with-border": e }, So, pe?.root), style: [(I) => ({ ...er({ theme: I, c: to, backgroundColor: oo, borderColor: no, rowBorderColor: ro, stripedColor: lo, highlightOnHoverColor: ao }), borderRadius: I.radius[t] || t, boxShadow: I.shadows[i] || i, height: r, minHeight: l, maxHeight: a }), Po, fe?.root, { position: "relative" }], children: [n.jsx(dr, { viewportRef: Wo, leftShadowBehind: re || !!m, rightShadowBehind: d, onScrollPositionChange: No, scrollAreaProps: po, children: n.jsx(Lo, { children: n.jsxs(Uo, { ref: Ro, horizontalSpacing: y, className: z("mantine-datatable-table", { [Ln]: o, "mantine-datatable-vertical-align-top": s === "top", "mantine-datatable-vertical-align-bottom": s === "bottom", "mantine-datatable-pin-last-column": d, "mantine-datatable-selection-column-visible": re, "mantine-datatable-pin-first-column": m, "mantine-datatable-resizable-columns": _e.hasResizableColumns && xe }, pe?.table), style: { ...fe?.table }, "data-striped": be && $t || void 0, "data-highlight-on-hover": Vt || void 0, ...Ee, children: [Ft ? null : n.jsx(mt, { ..._e, children: n.jsx(Un, { ref: X.header, selectionColumnHeaderRef: X.selectionColumnHeader, className: pe?.header, style: fe?.header, columns: Q, defaultColumnProps: c, groups: g, sortStatus: M, sortIcons: R, onSortStatusChange: W, selectionTrigger: v, selectionVisible: re, selectionChecked: ye, selectionIndeterminate: Ao && !ye, onSelectionChange: Eo, selectionCheckboxProps: { ...A, ...x }, selectorCellShadowVisible: Oe, selectionColumnClassName: S, selectionColumnStyle: T, withColumnBorders: Ee.withColumnBorders }) }), n.jsx("tbody", { ref: xo, children: be ? k.map((I, Y) => {
    let De = V(I, b), Ve = Ce?.includes(De) || !1, ct;
    return C && P && (ct = (Bo) => {
      if (Bo.nativeEvent.shiftKey && je !== null) {
        let le = k.filter(Y > je ? (ee, te) => te >= je && te <= Y && (j ? j(ee, te) : !0) : (ee, te) => te >= Y && te <= je && (j ? j(ee, te) : !0));
        C(Ve ? An(P, le, (ee) => V(ee, b)) : Fe([...P, ...le], (ee) => V(ee, b)));
      } else C(Ve ? P.filter((le) => V(le, b) !== De) : Fe([...P, I], (le) => V(le, b)));
      zo(Y);
    }), n.jsx(ir, { record: I, index: Y, columns: Q, defaultColumnProps: c, defaultColumnRender: f, selectionTrigger: v, selectionVisible: re, selectionChecked: Ve, onSelectionChange: ct, isRecordSelectable: j, selectionCheckboxProps: A, getSelectionCheckboxProps: N, onClick: Ht, onDoubleClick: Gt, onCellClick: Jt, onCellDoubleClick: Kt, onContextMenu: Qt, onCellContextMenu: Xt, expansion: Mo, color: so, backgroundColor: io, className: uo, style: ho, customAttributes: mo, selectorCellShadowVisible: Oe, selectionColumnClassName: S, selectionColumnStyle: T, idAccessor: b, rowFactory: To }, De);
  }) : n.jsx(vn, {}) }), Q.some(({ footer: I }) => I) && n.jsx(Dn, { ref: X.footer, className: pe?.footer, style: fe?.footer, columns: Q, defaultColumnProps: c, selectionVisible: re, selectorCellShadowVisible: Oe })] }) }) }), !!(w && be) && n.jsx(rr, { className: pe?.pagination, style: fe?.pagination, horizontalSpacing: y, fetching: u, page: w, onPageChange: Io, totalRecords: _, recordsPerPage: $, onRecordsPerPageChange: L, recordsPerPageOptions: K, recordsPerPageLabel: Z, paginationWithEdges: ce, paginationWithControls: de, paginationActiveTextColor: ue, paginationActiveBackgroundColor: he, paginationSize: U, paginationText: me, paginationWrapBreakpoint: ge, getPaginationControlProps: q, getPaginationItemProps: We, noRecordsText: lt, loadingText: Bt, recordsLength: be, renderPagination: Me }), n.jsx(Yn, { fetching: u, backgroundBlur: Ie, customContent: Et, size: zt, type: _t, color: Lt }), n.jsx(kn, { icon: Dt, text: lt, active: !u && !be, children: Ot })] }) });
}
const hr = "_root_1evgv_1", mr = {
  root: hr
}, wr = (e) => {
  const { minHeight: t = 200 } = e;
  return /* @__PURE__ */ n.jsx(
    ur,
    {
      className: mr.root,
      withRowBorders: !1,
      minHeight: t,
      ...e
    }
  );
};
export {
  wr as DataTable
};
